/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Auth otp payload
 */
export interface AuthOTPPayload { 
    /**
     * OTP Action
     */
    action?: AuthOTPPayload.ActionEnum;
    /**
     * Code channel
     */
    channel?: AuthOTPPayload.ChannelEnum;
    /**
     * Auth code
     */
    code?: string;
    /**
     * session Id
     */
    sessionId?: number;
    /**
     * step Id
     */
    stepId?: number;
}
export namespace AuthOTPPayload {
    export type ActionEnum = 'GENERATE_FROM_URL' | 'GENERATE_FROM_BTN' | 'VERIFY';
    export const ActionEnum = {
        GENERATEFROMURL: 'GENERATE_FROM_URL' as ActionEnum,
        GENERATEFROMBTN: 'GENERATE_FROM_BTN' as ActionEnum,
        VERIFY: 'VERIFY' as ActionEnum
    };
    export type ChannelEnum = 'SMS' | 'EMAIL';
    export const ChannelEnum = {
        SMS: 'SMS' as ChannelEnum,
        EMAIL: 'EMAIL' as ChannelEnum
    };
}
